/**
 * Copyright (C) COMPOFFICE-R Kft, RentIT - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 *
 */
RCA.client.Notes = (function () {
    'use strict';
    /* ----- Declare Variables ---------------------------------------------------------------------------------------- */
    var $templateNotesItem;

    /* ----- Init ----------------------------------------------------------------------------------------------------- */
    function Init() {
        $templateNotesItem = $('template#tplNotesItem').remove().contents();
        renderList();
        renderDetails();
        delete RCA.client.Notes.Init;
    }

    /* ----- Build Docs List ---------------------------------------------------------------------------------------- */
    function renderList() {
        var
            $self = $('#notes .notesList'),
            $fragmentNotes = $(document.createDocumentFragment());
        $.each(RCA.shared.AppData.notes, function (i, el) {
            var $clone = $templateNotesItem.clone();
            $clone.attr('data-index', el.id);
            $clone.find('.data-title').text(el.title);
            $clone.appendTo($fragmentNotes);
        });
        $self.html($fragmentNotes);
        $('#notes').find('.no-result').toggle(Boolean(!RCA.shared.AppData.notes.length));
    }

    function renderDetails() {
        if ('notes' in RCA.shared.localState) {
            var
                $header = $('#notes-details .data-label'),
                $details = $('#notes-details article'),
                data = RCA.shared.AppData.notes.find(function (el) {
                    return el.id === RCA.shared.localState.notes.itemIndex
                }) || [];
            $header.text(data.title || RCA.shared.Language.getItem('notes-new'));
            $details.find('input, textarea').val('');
            $details.find('.delete').toggleClass('hidden', !data.id);
            $.each(data, function (i, el) {
                $details.find('[name=' + i + ']').val(el || '');
            });
            if ('input' in RCA.shared.localState.notes) {
                $.each(RCA.shared.localState.notes.input, function (name, value) {
                    $details.find('[name="' + name + '"]').val(value);
                });
            }
        }
    }

    function evtClickItem(e) {
        RCA.shared.localState.notes = {
            itemIndex: String($(this).data('index')) || 0
        };
        renderDetails();
        if (e.data && e.data.title) {
            $('#notes-details [name="title"]').val(e.data.title);
        }
        RCA.client.Layout.show('notes-details');
    }

    function evtSubmitForm(e) {
        e.preventDefault();
        var
            $self = $(this),
            formData = RCA.shared.serializeObject($self);
        $self.addClass('disabled');
        RCA.shared.writeDbLog("note saved", "", "user_logs", "note");
        $.post('api/', {
            do: 'saveNote',
            data: formData
        }, function (res) {
            RCA.shared.AppData.notes = res;
            renderList();
            if(RCA.shared.AppData.settings.homeScreen === "floating") {
                $("#" + RCA.shared.localState.layout[RCA.shared.localState.layout.length - 2]).show();
                $("#" + RCA.shared.localState.layout[RCA.shared.localState.layout.length - 2]).attr("style", "background-color: transparent");
            }
            RCA.client.Layout.hide('notes-details');
            $self.removeClass('disabled');
        });
    }

    function evtResetForm(e) {
        e.preventDefault();
        var
            $self = $(this),
            id = $(this).closest('form').find('[name=id]').val();
        RCA.client.Modal.confirm(RCA.shared.Language.getItem('notes-confirm'), function () {
            $.post('api/', {
                do: 'removeNote',
                data: id
            }, function (res) {
                RCA.shared.AppData.notes = res;
                renderList();
                RCA.client.Layout.hide('notes-details');
                $self.removeClass('disabled');
            });
        });
    }

    function evtInputBackup() {
        var $this = $(this);
        if ($this.get(0).hasAttribute('name')) {
            RCA.shared.localState.notes.input = RCA.shared.localState.notes.input || {};
            RCA.shared.localState.notes.input[$this.attr('name')] = $this.val();
        }
    }

    function showDetails(id) {
        if (id) {
            if (RCA.shared.localState.notes != undefined) {
                if (id !== RCA.shared.localState.notes.itemIndex || RCA.shared.localState.notes.itemIndex === 0) {
                    RCA.shared.localState.notes.itemIndex = String(id);
                    renderDetails();
                }
            } else {
                RCA.shared.localState.notes = { 'itemIndex': String(id)};
            }
            RCA.client.Layout.show('notes-details');
        }
    }

    $(document)
        .on('click', '#notes .item', evtClickItem)
        .on('click', '#notes .new', evtClickItem)
        .on('click', '#notes-details form .delete', evtResetForm)
        .on('input', '#notes-details input, #notes-details textarea', evtInputBackup)
        .on('submit', '#notes-details form', evtSubmitForm);
    return {
        Init: Init,
        showDetails:showDetails,
        evtClickItem: evtClickItem
    }
})();
